import { ComponentType } from "react";
import VariantBaseline from "./VariantBaseline";
import VariantBoldValues from "./VariantBoldValues";
import VariantCenteredBalance from "./VariantCenteredBalance";
import VariantCombined from "./VariantCombined";
import VariantTeamPickV1 from "./VariantTeamPickV1";
import VariantTeamPickV2 from "./VariantTeamPickV2";
import { BackCardProps } from "./types";

export interface VariantDescriptor {
  id: string;
  name: string;
  Component: ComponentType<BackCardProps>;
}

export const BACK_CARD_VARIANTS: VariantDescriptor[] = [
  {
    id: "baseline",
    name: "Baseline (current production)",
    Component: VariantBaseline,
  },
  {
    id: "bold-values",
    name: "Bold values",
    Component: VariantBoldValues,
  },
  {
    id: "centered-balance",
    name: "Centered balance / bigger picks",
    Component: VariantCenteredBalance,
  },
  {
    id: "combined",
    name: "Combined + pop-on-flip",
    Component: VariantCombined,
  },
  {
    id: "team-pick-v1",
    name: "Team pick — iteration 1",
    Component: VariantTeamPickV1,
  },
  {
    id: "team-pick-v2",
    name: "Team pick — iteration 2",
    Component: VariantTeamPickV2,
  },
];

export type { BackCardProps } from "./types";
